import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import type { Invitation, PaginatedResponse } from "./types";

export function useTenantInvitations(tenantId: string, params?: Record<string, string>) {
  return useQuery<PaginatedResponse<Invitation>>({
    queryKey: ["tenant-invitations", tenantId, params],
    queryFn: async () => {
      const { data } = await client.get(`/tenants/${tenantId}/invitations/`, { params });
      return data;
    },
  });
}

export function useCreateInvitation(tenantId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { email: string; role: string }) => {
      const { data } = await client.post(`/tenants/${tenantId}/invitations/`, payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tenant-invitations", tenantId] });
    },
  });
}

export function useRevokeInvitation(tenantId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (invitationId: string) => {
      const { data } = await client.post(`/tenants/${tenantId}/invitations/${invitationId}/revoke/`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tenant-invitations", tenantId] });
    },
  });
}

export function useAcceptInvitation() {
  return useMutation({
    mutationFn: async (payload: {
      token: string;
      password: string;
      first_name: string;
      last_name: string;
    }) => {
      const { data } = await client.post("/invitations/accept", payload);
      return data;
    },
  });
}
